var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "room-setting-share-component p-5" }, [
    _c("div", { staticClass: "room-setting-content-box" }, [
      _c("h6", { staticClass: "room-setting-content-title" }, [
        _vm._v(_vm._s(_vm.$t("setting.share.doc.whiteSpace.title"))),
      ]),
      _c("div", { staticClass: "room-setting-content-text-box" }, [
        _c("p", { staticClass: "room-setting-content-text" }, [
          _vm._v(_vm._s(_vm.$t("setting.share.doc.whiteSpace.explain"))),
        ]),
      ]),
      _c("div", { staticClass: "room-setting-input-box" }, [
        _c("label", { staticClass: "room-setting-label" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.isDocShareMargin,
                expression: "isDocShareMargin",
              },
            ],
            staticClass: "room-setting-radio",
            attrs: { type: "checkbox", name: "useDocMargin" },
            domProps: {
              checked: Array.isArray(_vm.isDocShareMargin)
                ? _vm._i(_vm.isDocShareMargin, null) > -1
                : _vm.isDocShareMargin,
            },
            on: {
              click: function ($event) {
                return _vm.CHANGE_SETTING_DATA({
                  type: "useDocMargin",
                  value: !_vm.isDocShareMargin,
                })
              },
              change: function ($event) {
                var $$a = _vm.isDocShareMargin,
                  $$el = $event.target,
                  $$c = $$el.checked ? true : false
                if (Array.isArray($$a)) {
                  var $$v = null,
                    $$i = _vm._i($$a, $$v)
                  if ($$el.checked) {
                    $$i < 0 && (_vm.isDocShareMargin = $$a.concat([$$v]))
                  } else {
                    $$i > -1 &&
                      (_vm.isDocShareMargin = $$a
                        .slice(0, $$i)
                        .concat($$a.slice($$i + 1)))
                  }
                } else {
                  _vm.isDocShareMargin = $$c
                }
              },
            },
          }),
          _c("span", [
            _vm._v(_vm._s(_vm.$t("setting.share.doc.whiteSpace.use"))),
          ]),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }